import uuid from "react-native-uuid";

// Fixed namespace for deterministic v5 ids. Do not change — it would alter every
// generated join-row id and orphan existing links.
const JOIN_ID_NAMESPACE = "5b3f9946-b991-4765-9aad-8f7a2599d5e9";

// Deterministic UUID for a join row derived from its two foreign keys. Same pair
// always maps to the same UUID on every device, so concurrent offline adds of the
// same link converge to one row instead of fighting the unique constraint.
export function makeId(var1: string, var2: string): string {
  return uuid.v5(`${var1}:${var2}`, JOIN_ID_NAMESPACE) as string;
}
